import MaterialCommunityIcons from '@expo/vector-icons/MaterialCommunityIcons';
import { Colors } from '@gripp/shared-ui';
import { StyleSheet, Text, View } from 'react-native';
import { ModalButton } from '../../shared/components/modalButton';
import { EditWorkspaceForm } from './editWorkspaceForm';

type EditWorkspaceMenuProps = {
  label: any;
  workspaceId: string;
};

export const EditWorkspaceMenu = (props: EditWorkspaceMenuProps) => {
  return (
    <View style={styles.workspaceEditContainer}>
      <ModalButton
        label=""
        omitPadding={true}
        customButton={
          <View style={{ flexDirection: 'row' }}>
            <MaterialCommunityIcons
              name="pencil-outline"
              color={Colors.blackText}
              size={16}
              style={styles.icon}
            />
            <Text style={styles.label}>{props.label}</Text>
          </View>
        }
        buttonStyle={styles.editWorkspaceButton}
        modalComponent={({ onComplete }) => {
          return (
            <EditWorkspaceForm
              onComplete={onComplete}
              workspaceId={props.workspaceId}
            />
          );
        }}
        containerStyle={styles.modalContainer}
      />
    </View>
  );
};

const styles = StyleSheet.create({
  workspaceEditContainer: {
    flexDirection: 'row',
    alignItems: 'center',
    marginLeft: 20,
  },
  editWorkspaceButton: {
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
    width: 157,
    height: 32,
    backgroundColor: Colors.white,
    borderRadius: 16,
  },
  icon: {
    marginRight: 4,
  },
  label: {
    fontSize: 16,
    fontWeight: 500,
    letterSpacing: -0.25,
  },
  modalContainer: {
    alignSelf: 'center',
    backgroundColor: Colors.primaryGrayBackground,
    borderRadius: 10,
    width: 560,
    height: 218,
  },
});
